import { type ReactNode } from 'react';
import Header from '../Header';
import { Outlet } from 'react-router-dom';
import { Seo } from 'components/Seo';

interface IProps {
  /** Marshrutlar `Outlet` orqali — yoki (masalan, /courses) aniq sahifa */
  children?: ReactNode;
}

const MainLayout = ({ children }: IProps) => {
  return (
    <div className="flex min-h-screen w-full gap-3 bg-background p-3 md:gap-4 md:p-4">
      <Seo
        title="Boshqaruv paneli"
        description="Qizlar Akademiyasi boshqaruv paneli — kurslar, modullar va foydalanuvchilarni boshqarish."
        noindex
      />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-3">
        <Header />
        <div className="flex min-w-0 flex-1 overflow-x-hidden">
          <div className="w-full max-w-none flex-1 space-y-4 px-2 py-2 sm:px-4 sm:py-3 lg:px-6 lg:py-4 animate-in fade-in duration-500">
            {children ?? <Outlet />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
